<template>
  <div class="loading-infinite-message">
    <h2>
      {{
        warningText ? warningText : "A consulta possui mais de 1000 registros."
      }}
    </h2>
    <h3>Esse processo pode levar alguns segundos.</h3>
    <button
      class="md-button btn-secondary"
      @click="breakLoadingAndUpdateStatus"
    >
      Clique para interromper e refinar sua busca
    </button>
  </div>
</template>

<script>
export default {
  name: 'LoadingInfiniteMessage',
  props: ['breakLoading', 'updateStatusCount', 'warningText'],
  methods: {
    breakLoadingAndUpdateStatus () {
      this.breakLoading()
      this.updateStatusCount()
    }
  }
}
</script>

<style lang="scss" scoped>
  .loading-infinite-message {
    h2,
    h3 {
      text-transform: lowercase !important;

      &:first-letter { text-transform: capitalize; }
    }

    button.btn-secondary {
      background-color: #44ca9d !important;
    }
  }
</style>
